// @flow

import _ from 'lodash';
import ArrayUtils from '../utils/ArrayUtils';

import ApiObject from './ApiObject';
import Check from './Check';

export default class ChecksList extends ApiObject {

  checks: Array<Check> = [];

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize checks
    this.checks = [];
    const _this = this;

    // -- handle the case were the api responds a json with the array directly.
    let dataChecks = [];
    if (!_.isUndefined(data.checks)) {
      dataChecks = data.checks;
    } else {
      dataChecks = data;
    }

    _.each(dataChecks, (checkData: Object) => {
      const check:Check = new Check();
      check.fromJson(checkData);
      _this.checks.push(check);
    });
  }


  findById(idToFind: string): ?Check {
    return ArrayUtils.find(this.checks, (check: Check) => {
      return check.id == idToFind;
    });
  }
}
